// extracted by mini-css-extract-plugin
module.exports = {"popmessage":"PopMessage_popmessage__BWpMc","contents":"PopMessage_contents__1uJSS","message":"PopMessage_message__3oliN","button":"PopMessage_button__1m7ZH"};